import React from 'react';
import { Heading, Text } from '../common/Typography';

const pains = [
  {
    title: 'Stuck in the same rotation of players',
    detail: 'It feels like you have played the same people all session.',
  },
  {
    title: 'Unbalanced games',
    detail: 'The two sides are not at a similar level, so the game is one-sided.',
  },
  {
    title: 'Long waits',
    detail: 'You sit out for a stretch, then get two games back to back, instead of a steady wait between matches.',
  },
];

const outcomes = [
  {
    title: 'Balance',
    detail: 'Matches are scored to keep Elo closer, so games stay competitive.',
  },
  {
    title: 'Mix',
    detail: 'The queue varies partners and opponents instead of repeating the same players.',
  },
  {
    title: 'Fairer time on court',
    detail: 'Games-played fairness and a live court queue rotate who sits and who plays.',
  },
];

const LandingCommunity = () => (
  <section id="matchmaking" className="scroll-mt-24 px-4 py-12 sm:px-6 md:scroll-mt-8 lg:px-10 lg:py-16">
    <div className="mx-auto max-w-app-shell">
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-primary">
        Player-led matchmaking
      </p>
      <Heading level={2} className="max-w-3xl text-3xl sm:text-4xl">
        Built from the pains of real club nights.
      </Heading>

      <div className="mt-8 grid gap-4 sm:grid-cols-3">
        {pains.map((pain) => (
          <div key={pain.title} className="rounded-2xl border border-border-medium bg-surface p-5 shadow-brand-sm">
            <Heading level={3} className="mb-2 text-base">{pain.title}</Heading>
            <Text className="text-sm text-text-secondary">{pain.detail}</Text>
          </div>
        ))}
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        {outcomes.map((outcome) => (
          <div key={outcome.title} className="rounded-2xl border border-border-medium bg-surface p-5 shadow-brand-sm">
            <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-success-dark">
              {outcome.title}
            </p>
            <Text className="text-sm text-text-secondary">{outcome.detail}</Text>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default LandingCommunity;
